/* 🤖 this file was generated by svg-to-ts */
export const matIconImageAspectRatio: {
  name: 'image-aspect-ratio';
  data: string;
} = {
  name: 'image-aspect-ratio',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/></svg>`
};
